import { ASSISTANT_PENDING_TEXT } from '@/constants/chat'

/**
 * @param {Record<string, unknown>} prev
 * @param {Record<string, unknown>} patch
 */
export function patchGcpHostingDemoMessage(prev, patch) {
  return {
    ...prev,
    text: '',
    ...patch,
  }
}

/**
 * @param {(
 *   updater: (prev: Record<string, unknown[]>) => Record<string, unknown[]>
 * ) => void} setMessagesByThreadId
 * @param {string} tid
 * @param {string} pendingId
 * @param {Record<string, unknown>} patch
 */
export function updatePendingGcpHostingDemoMessage(setMessagesByThreadId, tid, pendingId, patch) {
  setMessagesByThreadId((inner) => {
    const list = [...(inner[tid] ?? [])]
    const idx = list.findIndex((m) => m.id === pendingId)
    if (idx === -1) return inner
    const next = [...list]
    next[idx] = patchGcpHostingDemoMessage(list[idx], patch)
    return { ...inner, [tid]: next }
  })
}
